var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoinbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    fill: "none",
    height: "100%",
    viewBox: "0 0 101 101",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "coinbase-wallet-logo"
  }, "Coinbase Wallet Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "coinbase-wallet-logo"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3633 100.363C77.9775 100.363 100.363 77.9775 100.363 50.3633C100.363 22.749 77.9775 0.363281 50.3633 0.363281C22.7491 0.363281 0.363297 22.749 0.363297 50.3633C0.363297 77.9775 22.7491 100.363 50.3633 100.363Z",
    fill: "#1B53E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15.23 50.3047C15.23 69.6721 30.9304 85.3725 50.2979 85.3725C69.6652 85.3725 85.3657 69.6721 85.3657 50.3047C85.3657 30.9372 69.6652 15.2369 50.2979 15.2369C30.9304 15.2369 15.23 30.9372 15.23 50.3047ZM43.5824 38.997C41.051 38.997 38.999 41.0491 38.999 43.5804V57.013C38.999 59.5442 41.051 61.5963 43.5824 61.5963H57.0149C59.5462 61.5963 61.5982 59.5442 61.5982 57.013V43.5804C61.5982 41.0491 59.5462 38.997 57.0149 38.997H43.5824Z",
    fill: "white",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinbase);
export default __webpack_public_path__ + "static/media/coinbase.5074806074f37ccfae2acb7be30aa6c4.svg";
export { ForwardRef as ReactComponent };